import BaseOptionsBundle from "%/dynamic-components/render-engine/classes/base-options";
import Padding from "%/dynamic-components/render-engine/options/spacing-options/padding";
import Margins from "%/dynamic-components/render-engine/options/spacing-options/margins";

export default class SpacingOptions extends BaseOptionsBundle {

  optionTitle = "Spacing";
  static optionClassName = "i-dynamic-spacing";

  constructor(values = {}, hideFromInspector = {}) {
    super(values, [
      new Padding(undefined, hideFromInspector["padding"] ?? false),
      new Margins(undefined, hideFromInspector["margins"] ?? false),
    ]);
  }
}
